"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateUtils = void 0;
var _DateUtils;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//DateUtils provides a common framework for working with date and time representations on the front-end, and 
//integrating with the backend's JsonDateString
//
//JsonDateString: A JsonDateString has a specific format, either the Date or the Date with Time.  If just a Date, assume time = midnight
//                The date only format is YYYY-MM-DD
//                The date with time format is YYYY-MM-DDTHH:MM:SS
var DateUtils = exports.DateUtils = /*#__PURE__*/function () {
  function DateUtils() {
    _classCallCheck(this, DateUtils);
  }
  return _createClass(DateUtils, null, [{
    key: "userTimeZone",
    value:
    //Return the user's timezone offset as a string like: UTC+0500, UTC-0230, etc  (hours and minutes)
    //If minutesWest is supplied, use that timezone offset, otherwise browser computed
    function userTimeZone(minutesWest) {
      var tzoffsetHrsDecimal;
      if (minutesWest == null) tzoffsetHrsDecimal = new Date().getTimezoneOffset() / -60; //hrs with fraction  
      else tzoffsetHrsDecimal = minutesWest / -60; //hrs with fraction

      var sign = tzoffsetHrsDecimal < 0 ? "-" : "+";
      var tzoffsetHrs = Math.floor(Math.abs(tzoffsetHrsDecimal));
      var tzoffsetMin = parseInt((Math.abs(tzoffsetHrsDecimal) - tzoffsetHrs) * 60);
      var hrsStr = String(tzoffsetHrs).padStart(2, '0');
      var minStr = String(tzoffsetMin).padStart(2, '0');
      return "UTC" + sign + hrsStr + minStr;
    }

    ///Returns the max year for calendar displays, 50 years in the future
  }, {
    key: "calendarMaxYear",
    value: function calendarMaxYear() {
      return new Date().getFullYear() + 50;
    }

    //Returns the current year
  }, {
    key: "currentYear",
    value: function currentYear() {
      return new Date().getFullYear();
    }

    /**
     * Given a Date object, return the String Hh:MM AM/PM in 12 hour format
     * @param {Date} date a Date object
     * @returns {String} the 12-hour time 
     */
  }, {
    key: "twelveHourFormat",
    value: function twelveHourFormat(date) {
      var hour = date.getHours();
      var min = date.getMinutes();
      var minString = String(min).padStart(2, "0");
      if (hour === 0) return "12:" + minString + "AM";else if (hour <= 11) return hour + ":" + minString + "AM";else if (hour === 12) return hour + ":" + minString + "PM";else return hour - 12 + ":" + minString + "PM";
    }
  }, {
    key: "twentyFourHourFormat",
    value: function twentyFourHourFormat(date) {
      var hour = date.getHours();
      var min = date.getMinutes();
      return hour + ":" + String(min).padStart(2, "0");
    }

    /**
     * Provides a String of the current time suitable for use in a filename for a downloaded file
     * @returns {String} a format of the date as YYYY MON DD HH.MM.SS
     */
  }, {
    key: "downloadTimeString",
    value: function downloadTimeString() {
      var date = new Date();
      var hours = String(date.getHours()).padStart(2, "0");
      var mins = String(date.getMinutes()).padStart(2, "0");
      var secs = String(date.getSeconds()).padStart(2, "0");
      return date.getFullYear() + " " + DateUtils.monthNames[date.getMonth()] + " " + date.getDate() + " " + hours + "." + mins + "." + secs;
    }

    /**
     * Format the date as a String suitable for display, date part only
     * @param {Date} date the Date object to format
     * @param {DateFormatType} format the enum of the desired format (if not set, default to ISO8601)
     * @returns {String} formatted as YYYY MON-DD or MON-DD YYYY, or the String "Invalid Format" if the format is invalid
     */
  }, {
    key: "dateFormat",
    value: function dateFormat(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DateUtils.DateFormatType.ISO8601;
      switch (format) {
        case DateUtils.DateFormatType.ISO8601:
          return date.getFullYear() + " " + DateUtils.monthNames[date.getMonth()] + "-" + dateVal(date);
        case DateUtils.DateFormatType.US:
          return DateUtils.monthNames[date.getMonth()] + "-" + dateVal(date) + " " + date.getFullYear();
        default:
          return "Invalid format";
      }
    }
  }, {
    key: "timeFormat",
    value:
    /**
     * Format the date as a String suitable for display and include the time part
     * @param {Date} date the Date object to format
     * @param {DateFormatType} format the enum of the desired format  (if not set, default to ISO8601)
     * @returns {String} formatted as YYYY MON-DD or MON-DD YYYY Hh:mm, or the String "Invalid Format" if the format is invalid
     */
    function timeFormat(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DateUtils.DateFormatType.ISO8601;
      switch (format) {
        case DateUtils.DateFormatType.ISO8601:
          return date.getFullYear() + " " + DateUtils.monthNames[date.getMonth()] + "-" + dateVal(date) + " " + DateUtils.twelveHourFormat(date);
        case DateUtils.DateFormatType.US:
          return DateUtils.monthNames[date.getMonth()] + "-" + dateVal(date) + " " + date.getFullYear() + " " + DateUtils.twelveHourFormat(date);
        default:
          return "Invalid format";
      }
    }

    /**
     * Given a number of minutes, format as a relative time string.  Leading items of zero values are left off
     * @param {Decimal} minutesValue
     * @returns {String} return as 00d 00h 00m
     */
  }, {
    key: "relativeTimeFormat",
    value: function relativeTimeFormat(minutesValue) {
      var split = splitRelativeTime(minutesValue);
      if (split.days === 0) {
        //leave off days
        split.days = "";
        if (split.hours === 0) split.hours = ""; //leave off hours
        else split.hours = split.hours + "h"; //include hours
      } else {
        //include days
        split.days = split.days + "d";
        split.hours = split.hours + "h";
      }
      split.minutes = split.minutes.toFixed(0) + "m";
      return (split.days + " " + split.hours + " " + split.minutes).trim();
    }

    /**
     * Given a number of minutes, format as a brief relative time string.  
     * @param {type} minutesValue
     * @returns {String} Using the greater than symbol to indicate more than 2 days, days/hours, >6 hours, or hours minutes
     */
  }, {
    key: "relativeTimeBriefFormat",
    value: function relativeTimeBriefFormat(minutesValue) {
      var split = splitRelativeTime(minutesValue);
      if (split.days >= 2) {
        return "> " + split.days + "d";
      } else if (split.days > 0) {
        return split.days + "d " + split.hours + " h";
      }
      //no days

      if (split.hours >= 6) {
        return "> " + split.hours + "h";
      }

      //very short
      return split.hours + "h " + split.minutes.toFixed(0) + "m";
    }

    /**
     * Given a number of minutes, format as a extended relative time string.  
     * @param {type} minutesValue
     * @returns {String} Indicate years, weeks, days, hours, and minutes
     */
  }, {
    key: "relativeTimeFriendlyFormat",
    value: function relativeTimeFriendlyFormat(minutesValue) {
      var split = splitRelativeTime(minutesValue);
      var years = 0;
      if (split.days > 365) {
        years = Math.floor(split.days / 365);
        split.days -= years * 365;
      }
      var weeks = 0;
      if (split.days > 7) {
        weeks = Math.floor(split.days / 7);
        split.days -= weeks * 7;
      }
      var str = (years > 0 ? years + (years > 1 ? " years, " : "year, ") : "") + (weeks > 0 ? weeks + (weeks > 1 ? " weeks, " : " week, ") : "") + (split.days > 0 ? split.days + (split.days > 1 ? " days, " : " day, ") : "") + (split.hours > 0 ? split.hours + (split.hours > 1 ? " hours, " : " hour, ") : "") + (split.minutes > 0 ? split.minutes + (split.minutes > 1 ? " minutes, " : " minute, ") : "");
      return str.slice(0, -2); //remove last comma and space
    }

    /**
     * Parse a JsonDateString from the backend and convert to a Date object
     * @param {String} dateString a String in JsonDateString format (see documentation at the top)
     * @param {boolean} isUTC if the dateString is in terms of UTC, false (default) if defined to be in local or generic date
     * @returns {Date} the parsed Date
     * @throws {Error} on parse error
     */
  }, {
    key: "parseJsonDate",
    value: function parseJsonDate(dateString) {
      var isUTC = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!dateString) throw new Error("Date String is empty");
      var split = dateString.trim().split(/[-:T]+/); //split by dash, colon, and T
      if (split.length !== 3 && split.length !== 6) throw new Error("Date String must have 3 or 6 pieces, separated by - : and T");
      var year = parseInt(split[0]);
      var mon = parseInt(split[1]);
      var day = parseInt(split[2]);
      var hr = 0;
      var min = 0;
      var sec = 0;
      if (split.length === 6) {
        hr = parseInt(split[3]);
        min = parseInt(split[4]);
        sec = parseInt(split[5]);
      }
      if (isUTC) return new Date(Date.UTC(year, mon - 1, day, hr, min, sec)); //UTC
      else return new Date(year, mon - 1, day, hr, min, sec); //local
    }

    /**
     * Convert a Date object to a JsonDateString
     * @param {Date} date the Date object to convert
     * @param {Boolean} withTime include the time (default true)
     * @returns {String} the JsonDateString
     */
  }, {
    key: "jsonDateString",
    value: function jsonDateString(date) {
      var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var monthString = String(date.getMonth() + 1).padStart(2, "0");
      var datePart = date.getFullYear() + "-" + monthString + "-" + dateVal(date);
      var timePart = "";
      if (withTime) {
        var hrString = String(date.getHours()).padStart(2, "0");
        var minString = String(date.getMinutes()).padStart(2, "0");
        var secString = String(date.getSeconds()).padStart(2, "0");
        timePart = "T" + hrString + ":" + minString + ":" + secString;
      }
      return datePart + timePart;
    }

    /**
    * Convert a Date object to a JsonDateString in UTC
    * @param {Date} date the Date object to convert
    * @param {Boolean} withTime include the time (default true)
    * @returns {String} the JsonDateString, UTC
    */
  }, {
    key: "jsonUTCDateString",
    value: function jsonUTCDateString(date) {
      var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var monthString = String(date.getUTCMonth() + 1).padStart(2, "0");
      var day = String(date.getUTCDate()).padStart(2, "0");
      var datePart = date.getUTCFullYear() + "-" + monthString + "-" + day;
      var timePart = "";
      if (withTime) {
        var hrString = String(date.getUTCHours()).padStart(2, "0");
        var minString = String(date.getUTCMinutes()).padStart(2, "0");
        var secString = String(date.getUTCSeconds()).padStart(2, "0");
        timePart = "T" + hrString + ":" + minString + ":" + secString;
      }
      return datePart + timePart;
    }

    /**
     * Parse a date represented as a String that has 3 parts, seperated by whitespace, slash, or dash
     * @param {String} dateString
     * @param {DateFormatType} format the enum that describes the format of the dateString
     * @param {Boolean} utc return Date in UTC format
     * @returns {Date} the parsed Date object
     * @throws {Error} on parse error
     */
  }, {
    key: "parseDate",
    value: function parseDate(dateString, format) {
      var utc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!dateString) throw new Error("Date String is empty");
      var split = dateString.trim().split(/[\s/-]+/); //split by whitespaces, slashes, or dashes
      if (split.length !== 3) throw new Error("Date String must have 3 pieces, separated by whitespace, / or -");
      var year, day, monthString;
      switch (format) {
        case DateUtils.DateFormatType.ISO8601:
          year = parseInt(split[0]);
          monthString = split[1];
          day = parseInt(split[2]);
          break;
        case DateUtils.DateFormatType.US:
          monthString = split[0];
          day = parseInt(split[1]);
          year = parseInt(split[2]);
          break;
        default:
          throw new Error("Invalid date format");
      }
      if (!year) throw new Error("Invalid year value");
      if (!day) throw new Error("Invalid day value");
      var numericMon = parseInt(monthString);
      if (!numericMon) numericMon = parseMonthWord(monthString);
      if (numericMon < 1 || numericMon > 12) throw new Error("Month value " + numericMon + " out of range (1-12)");
      if (day < 1 || day > 31) throw new Error("Day value " + day + " out of range (1-31)");
      if (utc) return new Date(Date.UTC(year, numericMon - 1, day));else return new Date(year, numericMon - 1, day);
    }

    /**
     * Parses a string datetime in the format YYYY-MM-DD HH:mm:ss
     * @param {String} dateString
     * @returns {Date} the parsed Date object in UTC
     * @throws {Error} on parse error
     */
  }, {
    key: "parseDateTime",
    value: function parseDateTime(dateString) {
      if (!dateString) throw new Error("Date String is empty");
      var split = dateString.trim().split(/[\s]+/); //split by whitespaces
      if (split.length > 2) throw new Error("Only spaces allowed are between date and time");
      var date = DateUtils.parseDate(split[0], DateUtils.DateFormatType.ISO8601, true);
      if (split.length > 1) {
        var splitTime = split[1].trim().split(":"); //split by colon
        if (splitTime.length !== 3) throw new Error("Time String must have 3 pieces, separated by colons");
        var hour = parseInt(splitTime[0]);
        var min = parseInt(splitTime[1]);
        var sec = parseInt(splitTime[2]);
        if (hour < 0 || hour > 23 || min < 0 || min > 59 || sec < 0 || sec > 59) throw new Error("Invalid time value, out of range value");
        date.setUTCHours(hour);
        date.setUTCMinutes(min);
        date.setUTCSeconds(sec);
      }
      return date;
    }

    /**
     * Provide an example of the format for the specified type
     * @param {DateFormatType} format the enum of the desired format
     * @returns {String} an example string, or the String "Invalid Format" if the format is invalid
     */
  }, {
    key: "exampleDateString",
    value: function exampleDateString(format) {
      switch (format) {
        case DateUtils.DateFormatType.ISO8601:
          return "YYYY-MMM-DD";
        case DateUtils.DateFormatType.US:
          return "MM-DD-YYYY";
        default:
          return "Invalid PP date format";
      }
    }

    /**
     * Create an array of years from min to max, if min not specified, use 1900
     * @param {integer} max year, if not defined or null, or less than 1900 then use the current year
     * @param {integer} min year, if not defined or null, use 1900
     * @returns {Array}
     */
  }, {
    key: "yearsArray",
    value: function yearsArray(max) {
      var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1900;
      var start = min ? min : 1900;
      var end = max && max >= 1900 ? max : new Date().getFullYear();
      var length = end - start + 1;
      return Array.from({
        length: length
      }, function (v, i) {
        return i + start;
      });
    }

    /**
     * Calculate the year age of a person from the supplied Date representing their birthdate
     * @param {Date} birthDate
     * @returns {Number} the number of years old the person is
     */
  }, {
    key: "calculateAge",
    value: function calculateAge(birthDate) {
      var now = DateUtils.startOfToday();
      var yearAge = now.getFullYear() - birthDate.getFullYear();
      now.setFullYear(birthDate.getFullYear());
      if (birthDate <= now)
        //has had birthday
        return yearAge;else return yearAge - 1;
    }

    /**
     * Get a Date object representing midnight on the current date
     * @returns {Date} midnight at the current date
     */
  }, {
    key: "startOfToday",
    value: function startOfToday() {
      var now = new Date();
      now.setHours(0, 0, 0, 0); //zero time component   
      return now;
    }

    /**
     * Get a Date object representing midnight on the first day of the current month
     * @returns {Date} midnight on the first day of the current month
     */
  }, {
    key: "startOfMonth",
    value: function startOfMonth() {
      var now = DateUtils.startOfToday();
      now.setDate(1);
      return now;
    }

    /**
     * Get a Date object representing midnight on the first day of the current year, or a given year
     * @param {Integer|Null} whichYear a given year for the Date, or the current year if null (default is null) 
     * @returns {Date} midnight on the first day of the current year, or a given year
     */
  }, {
    key: "startOfYear",
    value: function startOfYear() {
      var whichYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var now = DateUtils.startOfMonth();
      now.setMonth(0);
      if (whichYear === null)
        //null
        return now;
      now.setYear(whichYear);
      return now;
    }

    /**
     * Get a Date object representing midnight on the last day of the current year, or a given year
     * @param {Integer|Null} whichYear a given year for the Date, or the current year if null (default is null) 
     * @returns {Date} midnight on the last day of the current year, or a given year
     */
  }, {
    key: "lastDayOfYear",
    value: function lastDayOfYear() {
      var whichYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var now = DateUtils.startOfToday();
      now.setMonth(11); //december
      now.setDate(31);
      if (whichYear === null)
        //null
        return now;
      now.setYear(whichYear);
      return now;
    }

    /**
     * Parse and reformat a time string to be a common 24 hour format HH:MM with zero padded numbers as needed
     * @param {String} timeString
     * @returns {String} modified timeString
     */
  }, {
    key: "parseTimeString",
    value: function parseTimeString(timeString) {
      var timeParts = parseTime(timeString);

      //Zero pad
      if (timeParts.hr < 10) timeParts.hr = "0" + timeParts.hr;
      if (timeParts.min < 10) timeParts.min = "0" + timeParts.min;
      return timeParts.hr + ":" + timeParts.min;
    }

    /**
     * Parse and reformat a time string to be a common 12 hour format Hh:MM AM/PM with zero padded numbers as needed
     * @param {String} timeString
     * @returns {String} modified timeString
     */
  }, {
    key: "toFriendlyTimeString",
    value: function toFriendlyTimeString(timeString) {
      var timeParts = parseTime(timeString);
      if (timeParts.min < 10) timeParts.min = "0" + timeParts.min;
      if (timeParts.hr === 0) return "12:" + timeParts.min + "AM";else if (timeParts.hr <= 11) return timeParts.hr + ":" + timeParts.min + "AM";else if (timeParts.hr === 12) return timeParts.hr + ":" + timeParts.min + "PM";else return timeParts.hr - 12 + ":" + timeParts.min + "PM";
    }

    /**
     * Compares two time strings to determine the difference (in minutes) between them. 
     * @param {String{ t1 Time String
     * @param {String} t2 Time String
     * @returns {Number} minutes difference, if t2 > t1, value is positive, else negative
     */
  }, {
    key: "diffTimeStrings",
    value: function diffTimeStrings(t1, t2) {
      var timeParts1 = parseTime(t1);
      var timeParts2 = parseTime(t2);
      var t1Min = timeParts1.hr * 60 + timeParts1.min;
      var t2Min = timeParts2.hr * 60 + timeParts2.min;
      return t2Min - t1Min;
    }

    /**
     * Parse a relative time string that has one of the following formats, and return total minutes
     * 00d
     * 00h
     * 00m
     * 00d 00h
     * 00h 00m
     * 00d 00h 00m
     * 
     * @param {String} timeString relative time string as per above
     * @returns {Number} minutes difference, if t2 > t1, value is positive, else negative
    */
  }, {
    key: "parseRelativeTimeString",
    value: function parseRelativeTimeString(timeString) {
      if (!timeString) throw new Error("Time String is empty");
      var split = timeString.trim().split(/[\s:-]+/); //split by whitespaces, colon, or dashes

      var day = 0,
        hr = 0,
        min = 0;
      switch (split.length) {
        case 3:
          //three pieces must be day, hour, min
          day = parseInt(split[0]);
          hr = parseInt(split[1]);
          min = parseInt(split[2]);
          break;
        case 2:
          //two pieces may be day, hour or hour, min
          if (split[0].endsWith("d")) {
            day = parseInt(split[0]);
            hr = parseInt(split[1]);
          } else {
            hr = parseInt(split[0]);
            min = parseInt(split[1]);
          }
          break;
        case 1:
          //just one piece
          if (split[0].endsWith("d")) day = parseInt(split[0]);else if (split[0].endsWith("h")) hr = parseInt(split[0]);else min = parseInt(split[0]);
          break;
        default:
          throw new Error("Time String must have 2 or 3 pieces, separated by whitespace, - or :");
      }
      if (!day && day !== 0) throw new Error("Invalid day");
      if (!hr && hr !== 0) throw new Error("Invalid hour");
      if (!min && min !== 0) throw new Error("Invalid minute");
      if (day + hr + min <= 0) throw new Error("Time String must be greater than zero");
      return (day * 24 + hr) * 60 + min; //return total minutes
    }
  }]);
}(); //----------------- INTERNAL FUNCTIONS BELOW ----------------------------------
_DateUtils = DateUtils;
_defineProperty(DateUtils, "MS_PER_HOUR", 3600 * 1000);
_defineProperty(DateUtils, "MS_PER_DAY", 24 * _DateUtils.MS_PER_HOUR);
_defineProperty(DateUtils, "MS_PER_YEAR", _DateUtils.MS_PER_DAY * 365);
_defineProperty(DateUtils, "monthNames", ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]);
//Allowable date formats, international and US style
_defineProperty(DateUtils, "DateFormatType", {
  ISO8601: 'ISO8601',
  US: 'US',
  isOneOf: function isOneOf(type) {
    switch (type) {
      case _DateUtils.DateFormatType.ISO8601:
      case _DateUtils.DateFormatType.US:
        return true;
      default:
        return false;
    }
  }
});
function parseTime(timeString) {
  if (!timeString) throw new Error("Time String is empty");
  var split = timeString.trim().split(/[\s:-]+/); //split by whitespaces, colon, or dashes

  var hr, min, ampm;
  switch (split.length) {
    case 3:
      ampm = split[2];
    //fallthrough    
    case 2:
      hr = parseInt(split[0]);
      min = parseInt(split[1]);

      // handle case where no whitespace between am/pm
      if (split[1].endsWith("AM") || split[1].endsWith("am") || split[1].endsWith("PM") || split[1].endsWith("pm")) ampm = split[1].slice(-2);
      break;
    default:
      throw new Error("Time String must have 2 or 3 pieces, separated by whitespace, - or :");
  }
  if (!hr && hr !== 0) throw new Error("Invalid hour");
  if (!min && min !== 0) throw new Error("Invalid minute");
  if (hr < 0 || hr > 23) throw new Error("Hour value out of range (0-23)");
  if (min < 0 || min > 59) throw new Error("Minute value out of range (0-59)");

  //12 hour time
  if (ampm && ampm.toLowerCase() === 'pm') {
    if (hr > 0 && hr < 12)
      //convert pm hours to 24 hours
      hr += 12;
  } else if (ampm && ampm.toLowerCase() === 'am') {
    if (hr === 12)
      //12 am is 0
      hr = 0;
  }
  return {
    hr: hr,
    min: min
  };
}
function dateVal(date) {
  var day = date.getDate();
  return String(day).padStart(2, "0");
}
;
function splitRelativeTime(minutesValue) {
  var minutes = minutesValue;
  var days = Math.floor(minutes / (60 * 24)); //whole days
  minutes -= days * 60 * 24;
  var hours = Math.floor(minutes / 60); //whole hours
  minutes -= hours * 60;
  return {
    days: days,
    hours: hours,
    minutes: minutes
  };
}
;
function parseMonthWord(monthString) {
  var months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  var upperMonthString = monthString.toUpperCase();
  var monthVal = 0;
  months.forEach(function (month, index) {
    if (upperMonthString.startsWith(month)) {
      monthVal = index + 1;
    }
  });
  if (monthVal === 0) throw new Error("Invalid Month Value: " + monthString);
  return monthVal;
}